import { combineReducers } from "redux";
//import mainReducer from "@gc-npm/reducers.main-reducer";
import mainReducer from "@gc-npm/reducers.main-reducer";
import modalsReducer from "@gc-npm/reducers.modals-reducer";
import headerReducer from "@gc-npm/reducers.header-reducer";
import trackingReducer from '@gc-npm/reducers.tracking-reducer';
import hiperpersoCustomizerReducer from "@/reducers/hiperperso-customizer";

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
  tracking:trackingReducer,
  hiperpersoCustomizer: hiperpersoCustomizerReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
